import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Heading } from 'grommet';
import { useAppTheme } from '@Components/Context';
import {
  Seo, FullHeightBox, ResponsiveImage, Container, AppButton,
} from '@Components/Control';
import { localAsset } from '@Helpers/asset';


const Error404Page = () => {
  const navigate = useNavigate();
  const { theme: { page, button }, isDarkMode } = useAppTheme();
  const useImage = isDarkMode ? localAsset('images/logo/logo-full-white.svg') : localAsset('images/logo/logo-full-color.svg');
  const usePageBg = isDarkMode ? page.background : page.altBg;

  return (
    <FullHeightBox fill justify="center" background={usePageBg}>
      <Seo />
      <Container align="center" gap="large" pad="medium">
        <Box flex={false} width="20rem">
          <ResponsiveImage
            src={useImage}
            srcMobile={useImage}
            alt="Redflag Logo"
          />
        </Box>
        <Box gap="medium" align="center">
          <Heading level={1} size="large" textAlign="center" margin="none" color={page.primaryText}>
            404
          </Heading>
          <Heading thin level={2} size="large" textAlign="center" margin="none" color={page.primaryText}>
            Page Not Found
          </Heading>
          <Box width="100%" align="center" pad={{ top: '1rem' }}>
            <AppButton
              overrideHover
              width="7.25rem"
              height="3rem"
              onClick={() => navigate(-1)}
              level="dynamicLarge"
              color={button.primaryText}
              bgColor={button.primaryBg}
              fontWeight={600}
              label="Go back"
            />
          </Box>
        </Box>
      </Container>
    </FullHeightBox>
  );
};

export default Error404Page;
